/**
 * @generated SignedSource<<80f10004d4062a12fdb863ba549764dc>>
 * @relayHash 59f0519f908a00783bb64023ad19fee7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cefa642b8002fbccab8533b25b71da09e9d6f25c52e47c7333d1337fc0256f4b

import type { ConcreteRequest } from 'relay-runtime';
export type useIsPrivacyModeEnabledQuery$variables = {
  cloudId: string;
};
export type useIsPrivacyModeEnabledQuery$data = {
  readonly confluence_isPrivacyModeEnabled: {
    readonly isPrivacyModeEnabled: boolean;
  } | null;
};
export type useIsPrivacyModeEnabledQuery = {
  response: useIsPrivacyModeEnabledQuery$data;
  variables: useIsPrivacyModeEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluencePrivacyMode",
    "kind": "LinkedField",
    "name": "confluence_isPrivacyModeEnabled",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isPrivacyModeEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsPrivacyModeEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsPrivacyModeEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59f0519f908a00783bb64023ad19fee7",
    "id": "cefa642b8002fbccab8533b25b71da09e9d6f25c52e47c7333d1337fc0256f4b",
    "metadata": {},
    "name": "useIsPrivacyModeEnabledQuery",
    "operationKind": "query",
    "text": "query useIsPrivacyModeEnabledQuery($cloudId:ID!){confluence_isPrivacyModeEnabled(cloudId:$cloudId){isPrivacyModeEnabled}}"
  }
};
})();

(node as any).hash = "974739f746f3758748387ad8be18ef42";

export default node;
